import React from 'react';

import type { IconProps } from '@atlaskit/icon/types';

import intentSetUpSpaceIconUrl from '../assets/intent-set-up-space.svg';

export const IntentSetUpSpaceIcon = (_props: IconProps) => (
	<img
		src={intentSetUpSpaceIconUrl}
		alt=""
		width={24}
		height={24}
		role="presentation"
		aria-hidden="true"
	/>
);
